export type TipoApontamento = 'INIFIM' | 'TOTAL';

export const TIPOS_APONTAMENTO: ReadonlyArray<{ value: TipoApontamento; label: string }> = [
  { value: 'INIFIM', label: 'Início e fim' },
  { value: 'TOTAL', label: 'Total de horas' },
];

export interface ParametroSistemaDto {
  id: number;
  nome: string;
  casasDecimaisApontamento: number | null;
  chaveEmailSite: string | null;
  tipoApontamentoHora: TipoApontamento | null;
}

export interface ParametroSistemaInput {
  nome: string;
  casasDecimaisApontamento?: number | null;
  chaveEmailSite?: string | null;
  tipoApontamentoHora?: TipoApontamento | null;
}
